// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2idZv","author":"Table_author__2DJ2t","authorImage":"Table_authorImage__39Con","unreadRow":"Table_unreadRow__36GOS"};